import { IUser, IUserInfo } from '@/pages/Users/users.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import usersApi from '@/pages/Users/users.api.ts'
import usersEvents from '@/pages/Users/events/users.events.ts'
import UserFormFields from '@/pages/Users/components/UserFormFields'

interface IProps {
  user: IUser
  onCancel?: () => void
}

const EditUserSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft] = useStateWithChange<
    Omit<IUser, 'userInfo'> & { userInfo: Omit<IUserInfo, 'avatar' | 'telegram'> }
  >(props.user)

  useEffect(() => {
    setDraft(props.user)
  }, [props.user])

  const handleSave = () => {
    wait(
      usersApi.update(props.user.id, {
        active: draft.active,
        position: draft.position,
        email: draft.email,
        userInfo: {
          lastName: draft.userInfo.lastName,
          middleName: draft.userInfo.middleName,
          firstName: draft.userInfo.firstName,
          phoneNumber: draft.userInfo.phoneNumber,
        },
        roleId: draft.roleId,
      }),
      (resp) => {
        if (resp.status === 'success') {
          usersEvents.updated(resp.body)
          props.onCancel()
        }
      }
    )
  }

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleUserInfoChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, userInfo: { ...prev.userInfo, [name]: val } }))
  }

  return (
    <div className="flex-lines gap16 height100">
      <h4 className="text-heading-4">Редактирование сотрудника</h4>
      <SeparateLine />
      <UserFormFields user={draft} onChange={handleChange} onUserInfoChange={handleUserInfoChange} />
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <Button
          size="default"
          type="primary"
          text="Сохранить"
          loading={loading}
          disabled={!draft.userInfo.firstName || !draft.userInfo.lastName}
          onClick={handleSave}
        />
        <Button size="default" type="default" text="Отмена" disabled={loading} onClick={props.onCancel} />
      </div>
    </div>
  )
}

export default EditUserSidePageContent
